import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  getUserDetail as onGetUserDetail,
  getProfile as onGetProfile,
} from "store/actions"

import { getAuthUser } from "helpers/token_helper"
import { getUserImagePath } from "helpers/imageService"
import UserInfo from "pages/User/tabs/BasicInfoTab"
import { isEmpty } from "lodash"
// import { ToastContainer } from "react-toastify"
import { useDeepCompareEffect, useUserDetail } from "hooks"

const MyProfile = () => {
  const dispatch = useDispatch()
  const [profile, setProfile] = useState({})
  const { userprofile } = useUserDetail()

  //////////////////BASIC SETTING STATE/////////////////////
  const { basicSetting } = useSelector(state => state.Layout)
  //////////////////////////////////////

  //meta title
  document.title =
    "My Profile | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)
  useEffect(() => {
    if (getAuthUser()) {
      if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        setProfile(getAuthUser())
      }
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(userprofile)) {
      dispatch(onGetUserDetail(userprofile.RowID))
    }
  }, [userprofile])

  //////////////////STAFF STATE/////////////////////
  const { user, loading: userloading } = useSelector(state => state.user)
  //////////////////////////////////////

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Profile" breadcrumbItem="Your Profile" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={
                          !isEmpty(user)
                            ? getUserImagePath(user.RowID, "image.jpeg")
                            : ""
                        }
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        {!isEmpty(user) && (
                          <>
                            <h5>{user.Name}</h5>
                            <p className="mb-1">{user.Email}</p>
                            <p className="mb-1">{user.RoleType}</p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  {!isEmpty(user) && (
                    <UserInfo
                      user={user}
                      loading={userloading}
                      myprofile={true}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {/* <ToastContainer /> */}
    </React.Fragment>
  )
}
export default MyProfile
